$(document).ready(function() {
	if(!document.querySelector('.GPC0065')) return false;

	const $obj = $('.GPC0065');
	$obj.each(function() {
		const $this = $(this);
		/* PJTQUICKWIN 20220114 (조아라) - home type  추가로 인해 스크립트 변경  START */
		if($this.hasClass('hometype')) {
			const hometypeSlick = function(e) {
					if (!e.matches) { 
						if(!$this.find('.product-home-type .items').hasClass('slick-initialized')) {
							$hometypeSlick = $this.find('.product-home-type .items').slick({
								infinite: false,
								listStyle: true,
								slidesToShow: 4,
								slidesToScroll: 1,
								arrows : true,
								dots: false,
								responsive: [
									{
										breakpoint: 1200,
										settings: {
											slidesToShow: 2,
											slidesToScroll: 1
										}
									},
									{
										breakpoint: 768,
										settings: "unslick"
									}
								],
								prevArrow: carouselOptions.squarePrev,
								nextArrow: carouselOptions.squareNext 
							});
						} 
					} 
			};
			mql.maxSm.addListener(hometypeSlick);
			hometypeSlick(mql.maxSm);

			//hometype more button click
			const  $hometypeBtn = $this.find('.btn-more');
			if($this.find(".item").not('.item-signature').length > 4) {
				$hometypeBtn.addClass('show');
			}
			$hometypeBtn.off('click').on('click', function(e){
				e.preventDefault();
				$this.find('.item').not('.show').addClass('show');
				$hometypeBtn.removeClass('show');
			});
		} else {
			// home type 추가 전 코드
			const $slick = $this.find('.product-type .items').slick({
				infinite: false, // WA-GPC0065-01
				listStyle: true, // WA-GPC0065-01
				slidesToShow: 4,
				slidesToScroll: 1,
				arrows : true,
				dots: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 768,
						settings: {
							autoplay: false,
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: true,
							dots: true
						}
					}
				],
				prevArrow: carouselOptions.squarePrev, // common.js variable
				nextArrow: carouselOptions.squareNext // common.js variable
			});
			// link slick 
			$this.find('.item a.use-filter').on('click', function(e) {
				e.preventDefault();
				const linkUrl = $(this).attr('href');
				//const currURL = location.pathname;
				let title = changeTitleFormat($(this).find('.model-name.top').eq(0).text());
				if(!title || title=='') title = changeTitleFormat($(this).find('.model-name.bottom').eq(0).text());
				adobeSatellite('link_click', {'data-link-area':"category_selector-image", 'data-link-name':title});
				//console.log(linkUrl, currURL, linkUrl.indexOf(currURL));
				//if(linkUrl.indexOf(currURL)!=-1) {
					const filter = $(this).data('filter');
					const filterName = filter.split('=')[0];
					const filterValue = filter.split('=')[1];
					const obj = $('input[name='+filterName+'][value='+filterValue+']');
					if(obj.length>0) {
						const resetBtn = $('.filter-box .etc-box button[type=reset]');
						if(resetBtn.length>0) resetBtn.trigger('click');
						$('input[name='+filterName+']').prop('checked', false)
						if(!obj.prop('checked')) {
							//obj.prop('checked', 'checked');
							obj.trigger('click');
						}
						const t = parseInt($('.filter-box').offset().top);
						setTimeout(function() {
							$('html, body').stop().animate({scrollTop:(t)}, 500);
							$('.filter-box').attr('tabindex', -1).focus();
						}, 500)
					} else {
						location.href=linkUrl;
					}
				//} else {
					// url이 현재 페이지와 다른 경우 
				//	location.href=linkUrl;
				//}
			});
		}
		/* PJTQUICKWIN 20220114 (조아라) - home type  추가로 인해 스크립트 변경  END */
	});

	/* PJTPLP-10 (황규하) whitespace관련 START */
	const $headLine = $('[data-headLine]');
	$headLine.each(function() {
		$headLine.find('span').remove();
	});
	$obj.not('.hometype').each(function(){
		const $this = $(this);
		let r1 = false;
		let r2 = false;
		let r3 = false;
		const $r1El = $this.find('[data-headLine]');
		const $r2El = $this.find('[data-headCopy]');
		const $r3El = $this.find('[data-bodyCopy]');
		$r1El.each(function(){
			const val = $(this).text();
			if (!r1) {
				if($.trim(val)){
					r1 = true;
					return r1;
				}
			}
		});
		if(!r1){
			$r1El.remove();
		}
		$r2El.each(function(){
			const val2 = $(this).text();
			if (!r2) {
				if($.trim(val2)){
					r2 = true;
					return r2;
				}
			}
		});
		if(!r2){
			$r2El.remove();
		}
		$r3El.each(function(){
			const val3 = $(this).text();
			if (!r3) {
				if($.trim(val3)){
					r3 = true;
					return r3;
				}
			}
		});
		if(!r3){
			$r3El.remove();
		}
	});
	/* PJTPLP-10 (황규하) whitespace관련 END */
	
	/* LGECN-214, LGEITF-699 Start */
	if(lgCggroupName == 'home' && COUNTRY_CODE.toLowerCase() == 'cn' && typeof _hmt != 'undefined'){
	    $('.GPC0065').find('a, button').on('click', function(){
	        if($(this).hasClass('slick-prev')){
	        	console.log('[Baidu trackEvent] [Homepage_Product Category] [Click Previous]', ', $lg_cggroup : '+ $lg_cggroup);
	            _hmt.push(['_trackEvent',$lg_cggroup,'Click Previous','Homepage_Product Category']);
	        }else if($(this).hasClass('slick-next')){
	        	console.log('[Baidu trackEvent] [Homepage_Product Category] [Click Next]', ', $lg_cggroup : '+ $lg_cggroup);
	            _hmt.push(['_trackEvent',$lg_cggroup,'Click Next','Homepage_Product Category']);
	        }else if($(this).parents('.item')){
	        	var $clickContent = $(this).find('.body-copy').text();
	        	console.log('[Baidu trackEvent] [Homepage_Product Category] ', ', $lg_cggroup : '+ $lg_cggroup, ', $clickContent : '+$clickContent);
	            _hmt.push(['_trackEvent',$lg_cggroup,'Click '+$clickContent,'Homepage_Product Category']);
	        }	        
	    })
	}
	/* LGECN-214, LGEITF-699 End */
});